
import React, { useEffect, useRef, useState } from "react";

const CoverController = ({
  details,
  photoMode,
  PhotoComponent,
  NoPhotoComponent,
}) => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [hideScrollIndicator, setHideScrollIndicator] = useState(false);

  const autoScrollTimeout = useRef(null);
  const hasAutoScrolled = useRef(false);

  const removeIndicator = () => {
    if (!showScrollIndicator) return;

    setHideScrollIndicator(true);

    setTimeout(() => {
      setShowScrollIndicator(false);
    }, 3000);
  };

  const scrollDown = () => {
    clearTimeout(autoScrollTimeout.current);

    hasAutoScrolled.current = true;

    removeIndicator();

    window.scrollBy({
      top: 100,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    autoScrollTimeout.current = setTimeout(() => {
      scrollDown();
    }, 8000);

    return () => {
      clearTimeout(autoScrollTimeout.current);
    };
  }, []);

  useEffect(() => {
    const cancelAutoScroll = () => {
      clearTimeout(autoScrollTimeout.current);
      hasAutoScrolled.current = true;
      removeIndicator();
    };

    window.addEventListener("wheel", cancelAutoScroll, {
      passive: true,
    });

    window.addEventListener("touchmove", cancelAutoScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("wheel", cancelAutoScroll);
      window.removeEventListener("touchmove", cancelAutoScroll);
    };
  }, []);

  const databaseHasPhoto = details?.bannerType === "photo";

  const hasPhoto =
    photoMode === "photo"
      ? true
      : photoMode === "no-photo"
      ? false
      : databaseHasPhoto;

  const commonProps = {
    details,
    onScrollClick: scrollDown,
    showScrollIndicator,
    hideScrollIndicator,
  };

  return hasPhoto ? (
    <PhotoComponent {...commonProps} />
  ) : (
    <NoPhotoComponent {...commonProps} />
  );
};

export default CoverController;